<work-ui-modal #noteModal
               (modalClosedWithNoButton)="target.set(undefined)"
               [titleText]="'NOTIZ' | translate"
               modalId="montageplanNoteModal">
  <ng-container modal-body>
    @if (target(); as noteTarget) {
      <p class="margin-bottom-16">{{ 'MONTAGEPLAN_NOTIZ_HINWEIS' | translate:{ name: noteTarget.name, date: (noteTarget.date | formatDate) } }}</p>
      <work-ui-input-field [formControl]="noteFormControl"
                           [rows]="4"
                           [setAutoHeight]="true"
                           placeholder="NOTIZ"
                           variant="textarea" />

      @if (visibilityLoaded()) {
        <div class="margin-top-16">
          <p class="margin-bottom-8"><small><b>{{ 'MONTAGEPLAN_NOTIZ_SICHTBAR_FUER' | translate }}</b></small></p>
          <div class="flex wrap gap-8">
            @for (role of visibilityRoleEntries(); track role.id) {
              <work-ui-badge (click)="toggleRole(role.id)"
                             [clickable]="true"
                             [text]="role.label + ' (' + role.userCount + ')'"
                             [workUiTooltip]="role.userNamesText"
                             [workUiTooltipMaxWidth]="320"
                             size="small" />
            } @empty {
              <p class="work-text-color-light"><small>{{ 'MONTAGEPLAN_NOTIZ_SICHTBAR_KEINE_ROLLE' | translate }}</small></p>
            }
          </div>
          @for (role of visibilityRoleEntries(); track role.id) {
            @if (expandedRoleId() === role.id) {
              <p class="work-text-color-light margin-top-8">
                <small>{{ role.userNamesText || ('MONTAGEPLAN_NOTIZ_ROLLE_OHNE_PERSONEN' | translate) }}</small>
              </p>
            }
          }
        </div>
      }
    }
  </ng-container>
  <ng-container modal-footer>
    <div class="flex flex-row space-between width-100">
      @if (target()?.note) {
        <work-ui-button (buttonClick)="remove()"
                        [disabled]="saveLoadingState() === 'loading'"
                        text="ENTFERNEN"
                        variant="secondary" />
      } @else {
        <span></span>
      }
      <work-ui-button (buttonClick)="save()"
                      [disabled]="saveLoadingState() === 'loading' || noteFormControl.invalid"
                      text="SPEICHERN" />
    </div>
  </ng-container>
</work-ui-modal>
